const RELOADED_FOR_CHUNK_ERROR_KEY = 'reloaded-for-chunk-error';

interface VitePreloadErrorEvent extends Event {
  payload: unknown;
}

/**
 * After a deploy, Vite's content-hashed chunk filenames change, so a browser tab that's had
 * the app open since before the deploy can fail to load a chunk it references. Vite fires
 * `vite:preloadError` when this happens (https://vite.dev/guide/build.html#load-error-handling);
 * reload once to pick up the fresh assets, guarded by sessionStorage so a chunk that's still
 * stale after reloading (e.g. CDN cache lag) doesn't loop forever.
 */
export const setupChunkErrorReload = (): void => {
  window.addEventListener('vite:preloadError', event => {
    (event as VitePreloadErrorEvent).preventDefault();

    const path = window.location.pathname + window.location.search + window.location.hash;
    if (sessionStorage.getItem(RELOADED_FOR_CHUNK_ERROR_KEY) === path) {
      return;
    }
    sessionStorage.setItem(RELOADED_FOR_CHUNK_ERROR_KEY, path);
    window.location.href = path;
  });
};
